module.exports = __webpack_public_path__ + "img/delta_projects.2e48e28.png";